import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

/**
 * Validate email format
 * @param {string} email 
 * @returns {boolean}
 */
const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

const NewsletterSignup = () => {
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, error
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const trimmedEmail = email.trim();
    
    if (!trimmedEmail) {
      setStatus('error');
      setMessage('Please enter your email address');
      return;
    }

    if (!isValidEmail(trimmedEmail)) {
      setStatus('error');
      setMessage('Please enter a valid email address');
      return;
    }

    setStatus('loading');
    setMessage('');

    try {
      const response = await fetch('/api/newsletter/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ 
          email: trimmedEmail,
          newsletter_type: 'ai_notes'
        })
      });

      const data = await response.json();

      if (data.success) {
        // Navigate to appropriate confirmation page
        if (data.alreadySubscribed) {
          history.push('/newsletter/already-subscribed');
        } else {
          history.push('/newsletter/subscribed');
        }
      } else {
        setStatus('error');
        setMessage(data.error || 'Something went wrong. Please try again.');
      }
    } catch (err) {
      setStatus('error');
      setMessage('Something went wrong. Please try again.');
    }
  };

  return (
    <div style={{
      width: '100%',
      background: 'linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(248,250,252,0.9) 100%)',
      borderRadius: '16px',
      padding: '1.5rem',
      marginBottom: '1.5rem',
      boxShadow: '0 10px 25px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
      border: 'none',
      boxSizing: 'border-box'
    }}>
      <div style={{ maxWidth: '500px', margin: '0 auto' }}>
        {/* Header */}
        <div className="text-center mb-4">
          <h3 style={{
            fontSize: '1.5rem',
            fontWeight: '300',
            color: '#2d3748',
            marginBottom: '0',
            fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif'
          }}>
            Subscribe to AI Notes
          </h3>
        </div>
        
        {/* Form */}
        <form onSubmit={handleSubmit}>
          {/* Email Field */}
          <div className="mb-4">
            <label htmlFor="newsletter-email" style={{ position: 'absolute', left: '-9999px' }}>
              Email address for newsletter
            </label>
            <input
              type="email"
              id="newsletter-email"
              name="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (status === 'error') setStatus('idle');
              }}
              placeholder="your.email@example.com"
              disabled={status === 'loading'}
              style={{
                width: '100%',
                height: '50px',
                borderRadius: '8px',
                border: status === 'error' ? '2px solid #fc8181' : '2px solid #e2e8f0',
                fontSize: '1rem',
                fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
                padding: '0 16px',
                transition: 'border-color 0.2s ease',
                boxSizing: 'border-box',
                outline: 'none'
              }}
              onFocus={(e) => {
                if (status !== 'error') e.target.style.borderColor = '#667eea';
              }}
              onBlur={(e) => {
                if (status !== 'error') e.target.style.borderColor = '#e2e8f0';
              }}
            />
            {status === 'error' && (
              <div style={{ 
                color: '#c53030', 
                fontSize: '0.875rem', 
                marginTop: '0.5rem',
                fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif'
              }}>
                {message}
              </div>
            )}
          </div>

          {/* Submit Button - Full width */}
          <button
            type="submit"
            disabled={status === 'loading'}
            style={{
              width: '100%',
              backgroundColor: status === 'loading' ? '#a0aec0' : '#667eea',
              color: '#ffffff',
              border: 'none',
              borderRadius: '8px',
              padding: '14px 32px',
              fontSize: '1rem',
              fontWeight: '500',
              fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
              cursor: status === 'loading' ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s ease'
            }}
            onMouseOver={(e) => {
              if (status !== 'loading') {
                e.target.style.backgroundColor = '#5a67d8';
                e.target.style.transform = 'translateY(-1px)';
              }
            }}
            onMouseOut={(e) => {
              if (status !== 'loading') {
                e.target.style.backgroundColor = '#667eea';
                e.target.style.transform = 'translateY(0)';
              }
            }}
          >
            {status === 'loading' ? 'Subscribing...' : 'Subscribe'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default NewsletterSignup;
